import { Component, NgZone } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewDisputeComponent } from '../disputes/view-dispute/view-dispute.component';
import { DateService } from '../../shared/services/date.service';
import { ViewTransactionComponent } from '../transactions/view-transaction/view-transaction.component';

@Component({
  standalone: false,
  selector: 'app-refunds',
  templateUrl: './refunds.component.html',
  styleUrl: './refunds.component.scss'
})
export class RefundsComponent {

  gridApi: any;
  apiUrl: any;

  constructor(private _api: ApiService,
    private zone: NgZone,
    private modalService: NgbModal,
    private _dateService: DateService,
  ) {

  }

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      minWidth: 200,
      cellRenderer: (params: any) => {
        if (!params.data || !params.data.disputeId) {
          return `<span class="text-muted small">—</span>`;
        }
        return `
      <div class="d-flex gap-2 mt-1">
        <button class="btn btn-sm btn-outline-primary rounded-pill dispute-btn">Dispute</button>
        <button class="btn btn-sm btn-outline-success rounded-pill txn-btn">Transaction</button>
      </div>
    `;
      },
      onCellClicked: (params: any) => {
        if (params.event.target.classList.contains('dispute-btn')) {
          this.zone.run(() => this.onView(params));
        }
        if (params.event.target.classList.contains('txn-btn')) {
          this.zone.run(() => this.onTransactionView(params));
        }
      }
    },
    {
      headerName: 'Merchant Name',
      field: 'disputeId.transactionId.merchantName',
      editable: false,
      filter: true,
      width: 250
    },
    {
      headerName: 'Customer Name',
      field: 'disputeId.customerId.name',
      editable: false,
      filter: true,
      width: 250
    },
    {
      headerName: 'Amount',
      field: 'amount',
      editable: false,
      filter: true,
      valueGetter: (params) => {
        const transaction = params.data?.disputeId?.transactionId;
        if (transaction?.amount !== undefined) {
          return transaction.amount;
        }
        if (transaction?.conversions) {
          try {
            const conversions = JSON.parse(transaction.conversions);
            return conversions?.recipientGets?.amount;
          } catch (e) {
            return null;
          }
        }
        return null;
      }
    },
    {
      headerName: 'Approved By',
      field: 'userId.name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Approved Date',
      field: 'createdAt',
      editable: false,
      filter: false,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value)
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/refunds' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(function (k) {
          if (k && filterData[k]) {
            var filterValue = String(filterData[k].filter).replace(/[<>"';&]/g, '').slice(0, 200);
            if (!filterValue) return;
            if (k === 'amount') {
              vm.apiUrl += "&" + k + "_FULLMATCH=" + encodeURIComponent(filterValue);
            } else {
              vm.apiUrl += "&" + k + "_like=" + encodeURIComponent(filterValue);
            }
          }
        });
        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            const dt: any = [];
            Object.keys(res.data).map(r => {
              const obj = { type: r, value: res.data[r] };
              dt.push(obj);
            });
            console.log(dt);
            res.data.value = dt;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onView(params: any) {
    const vm = this;
    const modalRef = this.modalService.open(ViewDisputeComponent, { backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.disputeData = params.data.disputeId;
    modalRef.componentInstance.onSave.subscribe(() => {
      vm.gridApi.refreshInfiniteCache();
    });
  }

  onTransactionView(params: any) {
    const vm = this;
    const modalRef = vm.modalService.open(ViewTransactionComponent, { backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.transactionData = params.data.disputeId?.transactionId;
  }

}
